export default __webpack_public_path__ + "static/1320-5dc33f4a7a749b02720ccec5efaaacbe.gif";